import Vue from 'vue'
import Vuex from 'vuex'
import {AuthUser} from "./auth_user"
import {CounterParties} from "./counter_parties"
import {PerformanceParties} from "./perfomance_parties"
import {PostalCodes} from "./postal_codes"
import {RelationshipManagers} from "./relationship_managers";
import {Groups} from "./groups"
import {Report} from "./report";
import {Performance} from "./performance";
import {Branches} from "@/store/branches";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        AuthUser,
        CounterParties,
        PostalCodes,
        Groups,
        RelationshipManagers,
        Report,
        Performance,
        Branches,
        PerformanceParties
    },

    state: {},

    mutations: {},

    actions: {}
})
